export default __webpack_public_path__ + "static/media/Aeonik-SemiBoldItalic.d176c5ec.woff2";